export const ageCategory = ["Male", "Female", "Youth", "Children", "Toddler", "Inactive"];
    